export * from './TextAlignRightIcon';
export * from './TextAlignRightIcon16Light';
export * from './TextAlignRightIcon16Regular';
export * from './TextAlignRightIcon16Solid';
export * from './TextAlignRightIcon20Light';
export * from './TextAlignRightIcon20Regular';
export * from './TextAlignRightIcon20Solid';
export * from './TextAlignRightIcon24Regular';
export * from './TextAlignRightIcon24Solid';
export * from './TextAlignRightIcon32Regular';
export * from './TextAlignRightIcon64Regular';
